import { FC } from 'react'

import { EuiSpacer } from '@elastic/eui'

import { MasterCampaignPlan } from 'api/entities/MasterCampaignPlan'

import CustomizableSection from '../ExecutiveSummary/CustomizableSection'
import RenderCustomSections from '../RenderCustomSections'
import TabPageHeader from '../TabPageHeader'
import PersonaList from './PersonaList'

export interface PersonasProps {
  masterCampaignPlan: MasterCampaignPlan
}

const defaultIntroduction = 'The following personas are descriptive of the types of people we will be targeting. While fictional generalizations, they are based on research and market analysis. They will be used both in the targeting of your ad campaigns and in the crafting of your ads.'

const Personas: FC<PersonasProps> = ({ masterCampaignPlan }) => {
  const personas = masterCampaignPlan.personas || []
  const section = masterCampaignPlan.personaSection

  const pageTitle = section?.pageTitle || 'Persona Prioritization'

  return (
    <>
      <TabPageHeader title={pageTitle} />

      <CustomizableSection section={section?.introduction} defaultTitle='' defaultContent={defaultIntroduction} defaultShowTitle={false} separator='spacer' />
      <EuiSpacer size='xl' />

      <RenderCustomSections sections={section?.abovePersonaList} />

      <PersonaList personas={personas} />
    </>
  )
}

export default Personas
